"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanType = exports.PremiumPlanState = exports.PlanStatusType = exports.TripType = exports.Season = exports.FoodPreference = exports.TravellersType = void 0;
var TravellersType;
(function (TravellersType) {
    TravellersType["Solo"] = "Solo";
    TravellersType["Couple"] = "Couple";
    TravellersType["Family"] = "Family";
    TravellersType["Friends"] = "Friends";
})(TravellersType = exports.TravellersType || (exports.TravellersType = {}));
var FoodPreference;
(function (FoodPreference) {
    FoodPreference["Vegetarian"] = "Vegetarian";
    FoodPreference["NonVegetarian"] = "Non-Vegetarian";
    FoodPreference["Vegan"] = "Vegan";
    FoodPreference["Halal"] = "Halal";
    FoodPreference["StreetFood"] = "Street Food";
    FoodPreference["LocalFood"] = "Local Cuisine";
    FoodPreference["SeaFood"] = "Seafood";
    FoodPreference["Continental"] = "Continental";
    FoodPreference["Traditional"] = "Traditional";
    FoodPreference["Fusion"] = "Fusion";
    FoodPreference["GlutenFree"] = "Gluten-Free";
    FoodPreference["Organic"] = "Organic";
    FoodPreference["FarmToTable"] = "Farm-to-Table";
    FoodPreference["Desserts"] = "Desserts";
    FoodPreference["FineDining"] = "Fine Dining";
    FoodPreference["FastFood"] = "Fast Food";
    FoodPreference["HealthyChoices"] = "Healthy Choices";
    FoodPreference["Barbecue"] = "Barbecue";
    FoodPreference["Brunch"] = "Brunch";
    FoodPreference["CafesAndCoffeeShops"] = "Cafes and Coffee Shops";
})(FoodPreference = exports.FoodPreference || (exports.FoodPreference = {}));
var Season;
(function (Season) {
    Season["Winter"] = "Winter";
    Season["Spring"] = "Spring";
    Season["Summer"] = "Summer";
    Season["Autumn"] = "Autumn";
})(Season = exports.Season || (exports.Season = {}));
var TripType;
(function (TripType) {
    TripType["AdventureTour"] = "Adventure Tour";
    TripType["RelaxingBeachVacation"] = "Relaxing Beach Vacation";
    TripType["CitySightseeing"] = "City Sightseeing";
    TripType["WildlifeSafari"] = "Wildlife Safari";
    TripType["FoodAndCulinaryExperience"] = "Food and Culinary Experience";
    TripType["WellnessRetreat"] = "Wellness Retreat";
    TripType["IslandHopping"] = "Island Hopping";
    TripType["HistoricalHeritageTour"] = "Historical Heritage Tour";
    TripType["ScubaDivingAndSnorkeling"] = "Scuba Diving and Snorkeling";
    TripType["FamilyFriendlyVacation"] = "Family-Friendly Vacation";
    TripType["RomanticGetaway"] = "Romantic Getaway";
    TripType["BackpackingAdventure"] = "Backpacking Adventure";
})(TripType = exports.TripType || (exports.TripType = {}));
var PlanStatusType;
(function (PlanStatusType) {
    PlanStatusType["Draft"] = "pending";
    PlanStatusType["InReview"] = "inReview";
    PlanStatusType["Published"] = "published";
    PlanStatusType["Hidden"] = "hidden";
    PlanStatusType["Deleted"] = "deleted";
})(PlanStatusType = exports.PlanStatusType || (exports.PlanStatusType = {}));
var PremiumPlanState;
(function (PremiumPlanState) {
    PremiumPlanState["NotStarted"] = "notStarted";
    PremiumPlanState["InProgress"] = "inProgress";
    PremiumPlanState["Completed"] = "completed";
})(PremiumPlanState = exports.PremiumPlanState || (exports.PremiumPlanState = {}));
var PlanType;
(function (PlanType) {
    PlanType["Free"] = "free";
    PlanType["Premium"] = "premium";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
